import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { GoogleRedirectComponent } from "./modules/auth/google-redirect/google-redirect.component";
import { RoleGuard } from './core/auth/role.guard';
// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    // {path: '', pathMatch: 'full', redirectTo: 'schedavalutazione'},
    // {path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'schedavalutazione'},
    { path: '', pathMatch: 'full', redirectTo: 'call-overview' },
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'call-overview' },

    { path: 'google-oauth-success-redirect', component: GoogleRedirectComponent },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'forgot-password',
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)
            },
            {
                path: 'sign-in',
                loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)
            },
            {
                path: 'change-password',
                loadChildren: () => import('app/modules/auth/change-password/change-password.module').then(m => m.AuthChangePasswordModule)
            },


        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'call-overview',
                data: {
                    roles: ['Admin']
                },
                canLoad: [RoleGuard],
                loadChildren: () => import('app/modules/admin/call-overview/call-overview.module').then(m => m.CallOverviewModule)
            },

            {
                path: 'ssdf-call',
                data: {
                    roles: ['Admin']
                },
                loadChildren: () => import('app/modules/admin/ssdf-call/ssdf-call.module').then(m => m.SsdfCallModule)
            },
            {
                path: 'inverso-program',
                data: {
                    roles: ['Admin']
                },
                loadChildren: () => import('app/modules/admin/inverso-call/inverso-call.module').then(m => m.InversoCallModule)
            },
            {
                path: 'glitch-zone',
                data: {
                    roles: ['Admin']
                },
                loadChildren: () => import('app/modules/admin/glitch-zone/glitch-zone.module').then(m => m.GlitchZoneModule)
            },

            {
                path: 'sse',
                data: {
                    roles: ['Admin','Partner SSE']
                },
                canLoad: [RoleGuard],
                loadChildren: () => import('app/modules/admin/super-sapiens-europe/super-sapiens-europe.module').then(m => m.SuperSapiensEuropeModule)
            },
            {
                path: 'sse2',
                data: {
                    roles: ['Admin', 'Partner SSE']
                },
                canLoad: [RoleGuard],
                loadChildren: () => import('app/modules/admin/super-sapiens-europe-2/super-sapiens-europe.module').then(m => m.SuperSapiensEuropeModule)
            },

            // {
            //     path: 'menu-config',
            //     loadChildren: () => import('app/modules/admin/menu/menu.module').then(m => m.MenuModule)
            // },
        ]
    },


    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [

        ]
    },


];
